<template>
  <div class="palm_contract" >
    <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.push('/palm_configuration_page')">返回</el-button>
    <el-divider content-position="left">合同列表</el-divider>
    <el-row>
      <el-col :span="20">
        <el-select v-model="searchArr.flow_name"
          filterable remote reserve-keyword
          placeholder="请输入合同名称筛选"
          size="mini" clearable
          :remote-method="searchRemoteFlowNameMethod"
          :loading="searchLoading"
          @change="handleSearchFlowNameChange">
          <el-option v-for="searchFlow in searchFlows"
          :key="searchFlow.id"
          :label="searchFlow.flow_name"
          :value="searchFlow.id">
          </el-option>
        </el-select>
        <el-popover placement="bottom-start" v-model="visible" width="320">
          <el-form :model="searchArr" ref="searchForm" label-width="100px">
            <el-form-item label="发起方" prop="tx_company_id">
              <el-select v-model="searchArr.tx_company_id"
                filterable
                placeholder="请输入发起方名称筛选"
                size="mini"
                clearable>
                <el-option v-for="company in txElectronicCompanies"
                :key="company.id"
                :label="company.organization_name"
                :value="company.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发起人" prop="operator_id">
              <el-select v-model="searchArr.operator_id"
                filterable
                placeholder="请输入发起方名称筛选"
                size="mini"
                clearable>
                <el-option v-for="adminUser in adminUsers"
                :key="adminUser.id"
                :label="adminUser.username"
                :value="adminUser.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="个人签署方" prop="uid">
              <el-select v-model="searchArr.uid"
                filterable remote reserve-keyword
                placeholder="请输入姓名筛选个人签署方"
                size="mini" clearable
                :remote-method="searchRemoteUserMethod"
                :loading="searchUserLoading">
                <el-option v-for="searchUser in searchUsers"
                :key="searchUser.id"
                :label="searchUser.nickname"
                :value="searchUser.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同状态" prop="flow_status">
              <el-select v-model="searchArr.flow_status" placeholder="合同状态" clearable size="mini">
                <el-option label="合同签署中" value="PART"></el-option>
                <el-option label="合同签署完成" value="ALL"></el-option>
                <el-option label="合同拒签" value="REJECT"></el-option>
                <el-option label="合同撤回" value="CANCEL"></el-option>
                <el-option label="合同即将过期" value="WILLEXPIRE"></el-option>
                <el-option label="合同过期" value="DEADLINE"></el-option>
                <el-option label="解除协议" value="RELIEVED"></el-option>
                <el-option label="合同异常" value="EXCEPTION"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="tr">
              <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
              <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
    </el-row>
    <el-table :data="pageData" size="mini" border style="width: 100%; margin-top: .2rem" v-cloak>
      <el-table-column label="合同名称" prop="flow_name">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" :content="scope.row.flow_name" placement="top" :open-delay="500">
            <span class="hide-style">{{ scope.row.flow_name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发起方">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" :content="scope.row.tx_company.organization_name" placement="top" :open-delay="500">
            <span class="hide-style">{{ scope.row.tx_company.organization_name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发起人">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.admin_user.username }}</span>
        </template>
      </el-table-column>
      <el-table-column label="签署方">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.approvers" :key="index">
            <el-tooltip class="item"  effect="dark" :content="getOrganizationName(scope.row.tx_company.organization_name, item, scope.row.company, scope.row.type)" placement="top" :open-delay="500">
              <span class="hide-style">{{ getOrganizationName(scope.row.tx_company.organization_name, item, scope.row.company, scope.row.type) }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合同状态" prop="flow_status">
        <template slot-scope="scope">
          <span>{{ scope.row.flow_status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="合同类型" prop="flow_type"></el-table-column>
      <el-table-column label="发起时间" prop="created_at">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" :content="scope.row.created_at" placement="top" :open-delay="500">
            <span class="hide-style">{{ scope.row.created_at }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="过期时间" prop="dead_line">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" :content="scope.row.dead_line" placement="top" :open-delay="500">
            <span class="hide-style">{{ scope.row.dead_line }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" content="下载合同" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-download" circle @click="handpreviewOpen(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item"  effect="dark" content="撤销" placement="top" v-if="scope.row.flow_status === '合同创建' || scope.row.flow_status === '合同签署中' || scope.row.flow_status === '合同即将过期'">
            <el-button type="danger" size="mini" icon="el-icon-close" circle @click="handRevoke(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item"  effect="dark" content="生成合同二维码" placement="top" v-if="scope.row.flow_status === '合同创建' || scope.row.flow_status === '合同签署中' || scope.row.flow_status === '合同即将过期'">
            <el-button type="success" size="mini" icon="el-icon-menu" circle @click="handQrCodeOpen(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="tr mt-10"
      layout="total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-dialog title="合同二维码" :visible.sync="qrCodeVisible" :before-close="handleQrCodeClose" width="30%">
      <el-row class="text-align-c">
        <el-image :src="qrCode" style="border: 1px solid #ddd"></el-image>
      </el-row>
      <el-row class="mt-10 text-align-c">
        <span>请 {{ txCompany }} 法人使用认证过的微信扫码</span>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PalmContract',
  data () {
    return {
    	foldStyle: {
    	  marginLeft: '1.25rem !important',
    	},
    	unFoldStyle: {
    	  marginLeft: '3.6rem !important',
    	},
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 10 // 每页显示条数
      },
      searchArr: {
        flow_name: '',
        tx_company_id: '',
        flow_status: '',
        uid: '',
        operator_id: ''
      },
      searchLoading: false,
      searchFlows: [],
      visible: false,
      txElectronicCompanies: [],
      adminUsers: [],
      searchUserLoading: false,
      searchUsers: [],
      qrCodeVisible: false,
      qrCode: '',
      txCompany: ''
    }
  },
  computed: {
    collapse() {
      return this.$store.state.collapse
    },
  },
  methods: {
    getPageData () {
      this.$axios.get('/api/admin/qz_electronic_contract_controller/palm?page=' + this.pageOption.currentPage + this.searchStr)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.pageData = data.data.pageData.data
            this.pageOption.total = data.data.pageData.total
            this.txElectronicCompanies = data.data.txElectronicCompanies
            this.adminUsers = data.data.adminUsers
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getPageData()
    },
    searchRemoteFlowNameMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemFlows(query)
        }, 200)
      } else {
        this.searchFlows = []
      }
    },
    handleSearchFlowNameChange (val) {
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    searchArrItemFlows (query) {
      this.$axios.get('/api/admin/search_electronics?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.searchFlows = data.data.searchFlows
          }
        })
    },
    searchRemoteUserMethod (query) {
      if (query !== '') {
        this.searchUserLoading = true
        setTimeout(() => {
          this.searchUserLoading = false
          this.searchArrItemUsers(query)
        }, 200)
      } else {
        this.searchUsers = []
      }
    },
    searchArrItemUsers (query) {
      this.$axios.get('/api/admin/search_electronic_users?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.searchUsers = data.data.searchUsers
          }
        })
    },
    submitForm (formName) {
      this.visible = false
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    resetForm (formName) {
      this.visible = false
      this.searchArr.flow_name = ''
      this.$refs[formName].resetFields()
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    getOrganizationName (txName, item, company, type) {
      let str = ''
      if (item.organizationName) {
        str = item.organizationName + '_' + item.approveName
      } else {
        str = item.approveName
      }

      return str
    },
    handpreviewOpen (row) {
      this.$axios.post('/api/admin/qz_electronic_contract_controller/load/' + row.id)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            window.open(data.data.url)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handRevoke (row) {
      this.$confirm('是否确定撤销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/api/admin/qz_electronic_contract/cancel_flow/' + row.id)
          .then((res) => {
            let { data } = res
            if (data.code === 0) {
              this.getPageData()
              this.$message.success(data.msg)
            } else {
              this.$message.error(data.msg)
            }
          })
      }).catch(() => {})
    },
    handQrCodeOpen (row) {
      this.$axios.get('/api/admin/qz_electronic_contract/qr_code/' + row.id)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.qrCode = data.data.imgInfo
            this.txCompany = row.tx_company.organization_name
            this.qrCodeVisible = true
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleQrCodeClose (done) {
      this.qrCode = ''
      this.txCompany = ''
      done()
    }
  },
  mounted () {
    this.getPageData()
  }
}
</script>

<style lang="stylus" scoped>

.el-form-item
  margin-bottom: .1rem
.el-form .el-select
  width: 100%
.el-dialog .el-select
  width: 100%
.tr
  text-align: right
.text-align-c
  text-align: center
.mt-10
  margin-top: .2rem
.mt-20
  margin-top: .4rem
.el-form-item
  margin-bottom: .1rem
.palm_contract {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/pages/miniProZhangShangBanConfig/PalmContract.vue